import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { LayoutContext, TutorialDialog } from '@/_shared/components';
import { TutorialKeys } from '@/_shared/constants';
import { useTutorialCheck } from '@/_shared/hooks';
import { useDialog } from '@/_shared/hooks/useDialog';
import { getEmployeesStatsCall } from '@/people/state';
import { DepartmentsIntro, UsefulInformation } from '../components';
import { getDepartmentsCall } from '../state';

export const DepartmentsScreen = () => {
  const t = useTranslations('departments.tutorial.slides');
  const { setLayout } = useContext(LayoutContext);
  const { openDialog: openDialogDepartmentsTutorial } = useDialog('departmentsTutorial');
  const { hasAlreadySeenTutorial } = useTutorialCheck();
  const { departmentsToShowCount } = getDepartmentsCall.hook();
  const { completed } = getEmployeesStatsCall.hook();
  const showUsefulInformation = !(completed > 0 && departmentsToShowCount > 0);

  const slides = [
    {
      title: t('slide1.title'),
      description: t('slide1.description'),
      assetName: 'tutorialDepartmentsSlide1',
    },
    {
      title: t('slide2.title'),
      description: t('slide2.description'),
      assetName: 'tutorialDepartmentsSlide2',
    },
    {
      title: t('slide3.title'),
      description: t('slide3.description'),
      assetName: 'tutorialDepartmentsSlide3',
    },
  ];

  useEffect(() => {
    if (!hasAlreadySeenTutorial(TutorialKeys.Departments)) {
      openDialogDepartmentsTutorial();
    }
  }, [hasAlreadySeenTutorial, openDialogDepartmentsTutorial]);

  useEffect(() => {
    setLayout({ title: 'departments' });
  }, [setLayout, t]);

  return (
    <Box>
      <DepartmentsIntro />
      {showUsefulInformation ? <UsefulInformation /> : null}
      <TutorialDialog
        translationsKey='departments.tutorial'
        dialogKey='departmentsTutorial'
        slides={slides}
      />
    </Box>
  );
};
